import { Box } from '@mui/material'
import Dashboard from '../../components/Dashboard'
import TopSideBar from '../../components/TopSideBar'
import Copyright from '../../components/common/Copyright'
import PageContainer from '../../components/common/PageContainer'
import { PADDING_BASE } from '../../assets/Styles'
import Breadcrumbs from '../../components/common/Breadcrumbs'
import { Link } from 'react-router-dom'

export default function DashboardPage({ setBlockScreen }: any) {
  return <>
    <TopSideBar currentSection='dashboard' />
    <PageContainer>

      <Box paddingBottom={PADDING_BASE}>
        <Breadcrumbs pathlist={[
          <Link className='breadcrumbs-nav__link' to="/tickets/listing">
            Home
          </Link>,
          'Dashboard']}
        />
      </Box>

      <Dashboard
        setBlockScreen={setBlockScreen}
      />

    </PageContainer>
    <Copyright />
  </>
}